import { customFetchV2 } from "./fetch";

export interface SendStripeConnectOnboardingEmailParams {
  charityId: string;
  redirectUrl: string;
  stripeClientId: string;
  adminEmail: string;
}

export interface StripeConnectOnboardingEmailStatusResponse {
  lastSentEmail?: string;
  lastSentAt?: number;
  deliveryFailed?: boolean;
  deliveryStatus?: string;
  deliveryError?: string;
}

export async function sendStripeConnectOnboardingEmail(
  adminServiceUrl: string,
  charityId: string,
  token: string,
  params: Pick<
    SendStripeConnectOnboardingEmailParams,
    "redirectUrl" | "stripeClientId" | "adminEmail"
  >
): Promise<void> {
  const fullUrl = `${adminServiceUrl}/api/v1/${charityId}/stripe-connect/onboarding-email?token=${encodeURIComponent(
    token
  )}`;

  await customFetchV2({
    url: fullUrl,
    method: "POST",
    mode: "cors",
    body: JSON.stringify({
      redirectUrl: params.redirectUrl,
      stripeClientId: params.stripeClientId,
      adminEmail: params.adminEmail,
    }),
    headers: {
      "content-type": "application/json",
    },
  });
}

export async function getStripeConnectOnboardingEmailStatus(
  adminServiceUrl: string,
  charityId: string,
  token: string
): Promise<StripeConnectOnboardingEmailStatusResponse> {
  const fullUrl = `${adminServiceUrl}/api/v1/${charityId}/stripe-connect/onboarding-email-status?token=${encodeURIComponent(
    token
  )}`;

  return customFetchV2({
    url: fullUrl,
    method: "GET",
    mode: "cors",
    headers: {
      "content-type": "application/json",
    },
  });
}

export async function issueStripeConnectOAuthState(
  adminServiceUrl: string,
  charityId: string,
  token: string
): Promise<string> {
  const fullUrl = `${adminServiceUrl}/api/v1/${charityId}/stripe-connect/oauth-state?token=${encodeURIComponent(
    token
  )}`;

  const response: { state: string } = await customFetchV2({
    url: fullUrl,
    method: "POST",
    mode: "cors",
    headers: {
      "content-type": "application/json",
    },
  });
  return response.state;
}
